/** Classes' part of "Download my data": the caller's files here. */
export const myDataApi = '/classes/v1/me/data'
